import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@/components/ui/skeleton';
import { Separator } from '@/components/ui/separator';
const CartContentSkeleton = () => {
  const $ = _c(6);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center justify-between gap-3"><Skeleton className="h-5 w-40" /><Skeleton className="h-9 w-28 rounded-md" /></div>;
    t1 = <Separator />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col gap-4">{Array.from({
        length: 3
      }).map(_temp)}</div>;
    t3 = <Separator />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex justify-between"><Skeleton className="h-4 w-16" /><Skeleton className="h-4 w-20" /></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex w-full flex-col gap-6 rounded-lg bg-white p-6 shadow-sm">{t0}{t1}{t2}{t3}<div className="flex flex-col gap-2 px-1">{t4}<div className="flex justify-end"><Skeleton className="h-10 w-36 rounded-md" /></div></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
export default CartContentSkeleton;
function _temp(_, i) {
  return <div key={i} className="flex items-center gap-4 rounded-lg border p-4"><Skeleton className="aspect-[4/3] w-24 shrink-0 rounded-md" /><div className="flex flex-1 flex-col gap-2"><Skeleton className="h-4 w-3/4" /><Skeleton className="h-3 w-24" /></div><div className="flex flex-col items-end gap-2"><Skeleton className="h-4 w-16" /><Skeleton className="h-8 w-24 rounded-md" /></div></div>;
}